import { LANGUAGES } from '@ovh-ux/manager-config';
export function i18n(shell, environment) {
    return {
        getLocale: () => environment.getUserLocale(),
        setLocale: (locale) => {
            environment.setUserLocale(locale);
            shell.emitEvent('i18n:locale-change', { locale });
        },
        getAvailableLocales: () => LANGUAGES.available,
    };
}
//# sourceMappingURL=index.js.map